const allgap = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    grid: {
        left: '3%',
        right: '7%',
        top: '10%',
        bottom: '3%',
        containLabel: true
    },
    yAxis: [
        {
            type: 'value',
            axisLabel:{
                formatter:(v)=> (v/10000)+"万",
                color:'rgba(255,255,255,0.5)'
            },   // x轴字体颜色
            axisLine:{
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
            },
            axisTick:{
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
            },
            splitLine: {
                show: false
            },
            splitNumber:2,
        }
    ],
    xAxis: [
        {
            type: 'category',
            data: ['2020', '2021', '2022'],
            axisLabel:{color:'rgba(255,255,255,0.5)'},   // x轴字体颜色
            axisLine:{
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
            },
            axisTick:{
                // show: false,
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
            },
        }
    ],
    series: [
        {
            name: '缺口',
            type: 'bar',
            label: {
                show: false,
                position: 'inside'
            },
            barWidth:15,
            data: [0,0,0],
        },
        {
            name: '缺口',
            type: 'line',
            data: [0,0,0],
        },
        // {
        //     name: '供给',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //         show: false,
        //         position: 'inside'
        //     },
        //     data: [0,0,0],
        // },
        // {
        //     name: '需求',
        //     type: 'bar',
        //     stack: '总量',
        //     label: {
        //         show: false,
        //         position: 'inside'
        //     },
        //     data: [0,0,0],
        // },
    ] ,
    color:["#FF7875", "#3DABFF","#0A73FF"]
};

// const bkgap = {
//     tooltip: {
//         trigger: 'axis',
//         axisPointer: {            // 坐标轴指示器，坐标轴触发有效
//             type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
//         }
//     },
//     grid: {
//         left: '3%',
//         right: '7%',
//         top: '10%',
//         bottom: '3%',
//         containLabel: true
//     },
//     xAxis: [
//
//         {
//             type: 'value',
//             axisLabel:{
//                 formatter:(v)=> (v/10000)+"万",
//                 color:'rgba(255,255,255,0.5)'
//             },   // x轴字体颜色
//             axisLine:{
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
//             },
//             axisTick:{
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
//             },
//             splitLine: {
//                 show: false
//             },
//             splitNumber:2,
//         }
//         ],
//     yAxis: [
//         {
//             type: 'category',
//             data: ['2020', '2021', '2022'],
//             axisLabel:{color:'rgba(255,255,255,0.5)'},   // x轴字体颜色
//             axisLine:{
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
//             },
//             axisTick:{
//                 // show: false,
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
//             },
//         }
//     ],
//     series: [
//         {
//             name: '缺口',
//             type: 'bar',
//             label: {
//                 show: false,
//                 position: 'inside'
//             },
//             barWidth:15,
//             data: [0,0,0],
//         },
//         // {
//         //     name: '供给',
//         //     type: 'bar',
//         //     stack: '总量',
//         //     label: {
//         //         show: false,
//         //         position: 'inside'
//         //     },
//         //     data: [0,0,0],
//         // },
//         // {
//         //     name: '需求',
//         //     type: 'bar',
//         //     stack: '总量',
//         //     label: {
//         //         show: false,
//         //         position: 'inside'
//         //     },
//         //     data: [0,0,0],
//         // },
//     ] ,
//     color:["#FF7875", "#3DABFF","#0A73FF"]
// };

const gzgap = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    grid: {
        left: '3%',
        right: '7%',
        top: '12%',
        bottom: '1%',
        containLabel: true
    },
    yAxis: [
        {
            type: 'value',
            axisLabel:{
                formatter:(v)=> (v/10000)+"万",
                color:'rgba(255,255,255,0.5)'
            },   // x轴字体颜色
            axisLine:{
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
            },
            axisTick:{
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
            },
            splitLine: {
                show: false
            },
            splitNumber:2,
        }    ],
    xAxis: [
        {
            type: 'category',
            data: ['2020', '2021', '2022'],
            axisLabel:{color:'rgba(255,255,255,0.5)'},   // x轴字体颜色
            axisLine:{
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
            },
            axisTick:{
                // show: false,
                lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
            },
        }
    ],
    legend: {
        orient: 'horizontal',
        right: 0,
        // bottom: -10,
        data: ['中职', '高职', '本科'],
        icon:'circle',
        itemWidth:20,
        textStyle:{
            fontSize:10,
            color:'#fff',
        }
    },
    series: [
        {
            name: '中职',
            type: 'bar',
            label: {
                show: false,
                position: 'inside'
            },
            barWidth:15,
            data: [0,0,0],
        },
        {
            name: '高职',
            type: 'bar',
            label: {
                show: false,
                position: 'inside'
            },
            barWidth:15,
            data: [0,0,0],
        },
        {
            name: '本科',
            type: 'bar',
            label: {
                show: false,
                position: 'inside'
            },
            barWidth:15,
            data: [0,0,0],
        },
    ] ,
    color:["#04DCFF", "#DFBF65","#DF6F71"]
    // color:["#FF7875", "#3DABFF","#0A73FF"]
};

// const zzgap = {
//     tooltip: {
//         trigger: 'axis',
//         axisPointer: {            // 坐标轴指示器，坐标轴触发有效
//             type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
//         }
//     },
//     grid: {
//         left: '3%',
//         right: '7%',
//         top: '10%',
//         bottom: '3%',
//         containLabel: true
//     },
//     xAxis: [
//
//         {
//             type: 'value',
//             axisLabel:{
//                 formatter:(v)=> (v/10000)+"万",
//                 color:'rgba(255,255,255,0.5)'
//             },   // x轴字体颜色
//             axisLine:{
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
//             },
//             axisTick:{
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
//             },
//             splitLine: {
//                 show: false
//             },
//             splitNumber:2,
//         }    ],
//     yAxis: [
//         {
//             type: 'category',
//             data: ['2020', '2021', '2022'],
//             axisLabel:{color:'rgba(255,255,255,0.5)'},   // x轴字体颜色
//             axisLine:{
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
//             },
//             axisTick:{
//                 // show: false,
//                 lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
//             },
//         }
//     ],
//     series: [
//         {
//             name: '缺口',
//             type: 'bar',
//             label: {
//                 show: false,
//                 position: 'inside'
//             },
//             barWidth:15,
//             data: [0,0,0],
//         },
//         // {
//         //     name: '供给',
//         //     type: 'bar',
//         //     stack: '总量',
//         //     label: {
//         //         show: false,
//         //         position: 'inside'
//         //     },
//         //     data: [0,0,0],
//         // },
//         // {
//         //     name: '需求',
//         //     type: 'bar',
//         //     stack: '总量',
//         //     label: {
//         //         show: false,
//         //         position: 'inside'
//         //     },
//         //     data: [0,0,0],
//         // },
//     ] ,
//     color:["#FF7875", "#3DABFF","#0A73FF"]
// };

const allneed = {
    tooltip: {
        formatter: (p)=>`${p.data[0]}年 ${p.seriesName}:<br>${p.value[p.encode.y[0]]}人`
    },
    grid: {
        left: '3%',
        right: '5%',
        top: '10%',
        bottom: '3%',
        containLabel: true
    },
    legend: {
        orient: 'horizontal',
        right: 0,
        // bottom: -10,
        data: ['中职', '高职', '本科'],
        icon:'circle',
        itemWidth:20,
        textStyle:{
            fontSize:10,
            color:'#fff',
        }
    },
    dataset: {
        source: [
            ['2018', 0,0,0],
            ['2019', 0,0,0],
            ['2020', 0,0,0],
        ],
    },

    xAxis: {
        type: 'category',
        axisLabel:{color:'rgba(255,255,255,0.5)'},   // x轴字体颜色
        axisLine:{
            lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
        },
        axisTick:{
            lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
        },
    },
    yAxis: {
        axisLine:{       //y轴
            "show":false
        },
        axisTick:{       //y轴刻度线
            "show":false
        },
        axisLabel : {
            formatter: ()=>""
        },
        splitLine: {
            show: false
        }
    },
    series: [
        {name:"中职", type: 'bar', barWidth :10},
        {name:"高职", type: 'bar', barWidth :10},
        {name:"本科", type: 'bar', barWidth :10},
        {name:"需求趋势", type: 'line', lineStyle:{color:"#23FB20"}},
    ],
    color:["#04DCFF", "#DFBF65","#DF6F71"]
};

const allprovide = {
    tooltip: {
        formatter: (p)=>`${p.data[0]}年 ${p.seriesName}:<br>${p.value[p.encode.y[0]]}人`
    },
    grid: {
        left: '3%',
        right: '5%',
        top: '11%',
        bottom: '3%',
        containLabel: true
    },
    legend: {
        orient: 'horizontal',
        right: 0,
        // bottom: -10,
        data: ['中职', '高职', '本科'],
        icon:'circle',
        itemWidth:20,
        textStyle:{
            fontSize:10,
            color:'#fff',
        }
    },
    dataset: {
        source: [
            ['2018', 0,0,0],
            ['2019', 0,0,0],
            ['2020', 0,0,0],
        ],
    },

    xAxis: {
        type: 'category',
        axisLabel:{color:'rgba(255,255,255,0.5)'},   // x轴字体颜色
        axisLine:{
            lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴坐标轴颜色
        },
        axisTick:{
            lineStyle:{color:'rgba(255,255,255,0.2)'}    // x轴刻度的颜色
        },
    },
    yAxis: {
        axisLine:{       //y轴
            "show":false
        },
        axisTick:{       //y轴刻度线
            "show":false
        },
        axisLabel : {
            formatter: ()=>""
        },
        splitLine: {
            show: false
        }
    },
    series: [
        {name:"中职", type: 'bar', barWidth :10},
        {name:"高职", type: 'bar', barWidth :10},
        {name:"本科", type: 'bar', barWidth :10},
        {name:"培养趋势", type: 'line',lineStyle:{color:"#23FB20"}},
    ],
    color:["#04DCFF", "#DFBF65","#DF6F71"]
};

// 产业布局
const industrypos = {
    tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
    },
    legend: {
        orient: 'vertical',
        right: 0,
        data: ['东部', '西部', '中部'],
        textStyle:{
            color:'#fff',
        }
    },
    series: [
        {
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
                {value: 0, name: '东部'},
                {value: 0, name: '西部'},
                {value: 0, name: '中部'}
            ],
            label: {
                show: false,
                position: 'center'
            },
        }
    ],

    color:["#d54062", "#28df99","#ebdc87"]
    // color:["#04DCFF", "#DFBF65","#DF6F71"]
};

// 专业布局
const majorpos = {
    tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
    },
    legend: {
        orient: 'vertical',
        right: 0,
        data: ['东部', '西部', '中部'],
        textStyle:{
            color:'#fff',
        }
    },
    series: [
        {
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
                {value: 0, name: '东部'},
                {value: 0, name: '西部'},
                {value: 0, name: '中部'}
            ],
            label: {
                show: false,
                position: 'center'
            },
        }
    ],
    color:["#d54062", "#28df99","#ebdc87"]
};

// 职业岗位能力要求
var needkeywords = {
    tooltip: false,
    series: [ {
        type: 'wordCloud',
        gridSize:5,
        sizeRange: [12, 20],
        rotationRange: [0, 0],
        rotationStep: 90,
        shape: 'pentagon',
        width: 300,
        height:200,
        drawOutOfBound: true,
        textStyle: {
            normal: {
                color: function () {
                    let color = ['#B8D4EA',"#ECA2C5",'#0D8311',"#FFEC61","#4DCB8C",'#DCCFE3',"#E92121",'#4C5619',"#F87433","#FBF36E"];
                    let num =Math.floor(Math.random() * (5));
                    return color[num];
                }
            },
            emphasis: {
                shadowBlur: 10,
                shadowColor: '#333'
            }
        },
        data: []
    } ]
};

//专业培养能力要求
const providekeywords = {
    tooltip: false,
    series: [ {
        type: 'wordCloud',
        gridSize:5,
        sizeRange: [12, 20],
        rotationRange: [0, 0],
        rotationStep: 90,
        shape: 'pentagon',
        width: 300,
        height:200,
        drawOutOfBound: true,
        textStyle: {
            normal: {
                color: function () {
                    let color = ['#B8D4EA',"#ECA2C5",'#0D8311',"#FFEC61","#4DCB8C",'#DCCFE3',"#E92121",'#4C5619',"#F87433","#FBF36E"];
                    let num =Math.floor(Math.random() * (5));
                    return color[num];
                }
            },
            emphasis: {
                shadowBlur: 10,
                shadowColor: '#333'
            }
        },
        data: []
    } ]
};

const jobcharts = {
    tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
    },
    series: [
        {
            type: 'tree',
            data: [],
            left: '20%',
            bottom: '1%',
            right: '20%',

            symbolSize: 6,
            initialTreeDepth:5,
            orient: 'RL',
            lineStyle:{
                color:'#666',
            },

            label: {
                fontSize: 13,
                color: "#eaeaea",
                position: 'right',
                verticalAlign: 'middle',
                align: 'left',
                // padding: 4
            },

            leaves: {
                label: {
                    position: 'left',
                    verticalAlign: 'middle',
                    align: 'right',
                }
            },

            emphasis: {
                focus: 'descendant'
            },

            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750
        }
    ]
}

const industrycharts = {
    tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
    },
    series: [
        {
            type: 'tree',
            data: [],
            left: '20%',
            bottom: '1%',
            right: '20%',

            symbolSize: 6,
            initialTreeDepth:5,
            orient: 'LR',
            lineStyle:{
                color:'#666',
            },

            label: {
                fontSize: 13,
                color: "#eaeaea",
                position: 'left',
                verticalAlign: 'middle',
                align: 'right',
                // padding: 4
            },

            leaves: {
                label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                }
            },

            emphasis: {
                focus: 'descendant'
            },

            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750
        }
    ]
}



export default {
    allgap,
    // bkgap,
    gzgap,
    // zzgap,
    allneed,
    allprovide,
    industrypos,
    majorpos,
    needkeywords,
    providekeywords,
    jobcharts,
    industrycharts,
};
